import axios from "axios";
import authHeader from "./auth-header";

import { API_URL } from "./constants";

class CloseoutService {
  requestCloseout(data) {
    return axios.post(API_URL + "closeout/requesting", data, {
      headers: authHeader(),
    });
  }
}

export default new CloseoutService();
